export default {
  federations: '/mrx-gateway/mrxassistmemberservice/admin/api/sso/federation',
  changeFederations: federationId => `/mrx-gateway/mrxassistmemberservice/admin/api/sso/federation/${federationId}`,

  federationSsoGroups: federationId => `/mrx-gateway/mrxassistmemberservice/admin/api/sso/federation/${federationId}/ssogroups`,
  changeFederationSsoGroups: (federationId, roleName, userGroup) => `/mrx-gateway/mrxassistmemberservice/admin/api/sso/federation/${federationId}/ssogroups/${roleName}/${userGroup}`
}
